<!-- Search icon button (collapsed state) -->
@if (!opened()) {
  <button mat-icon-button (click)="open()" [title]="'globalSearch.openButton' | transloco">
    <mat-icon [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
  </button>
}

<!-- Search bar (expanded state) -->
@if (opened()) {
  <div
    class="bg-card absolute right-2 top-1 z-99 flex w-full max-w-xl shrink-0 flex-col overflow-hidden rounded-xl shadow-2xl"
    @slideInTop
    @slideOutTop
  >
    <!-- Input row -->
    <div class="flex h-16 flex-shrink-0 items-center px-4">
      <mat-icon
        class="mr-3 text-secondary"
        [svgIcon]="'heroicons_outline:magnifying-glass'"
      ></mat-icon>
      <input
        #searchInput
        class="min-w-0 flex-1 bg-transparent text-base outline-none placeholder:text-gray-400"
        type="text"
        [placeholder]="'globalSearch.placeholder' | transloco"
        [ngModel]="searchService.query()"
        (ngModelChange)="onQueryChange($event)"
        (keydown)="onKeydown($event)"
        autocomplete="off"
      />
      @if (searchService.isLoading()) {
        <div class="ml-3 h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-primary"></div>
      }
      <button class="ml-2" mat-icon-button (click)="close()">
        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
    </div>

    <!-- Results panel (only when query >= 2 chars) -->
    @if (searchService.query().trim().length >= 2) {
      <div class="flex max-h-[70vh] flex-col overflow-hidden border-t">

        <!-- Tabs -->
        <div class="flex flex-shrink-0 gap-1 overflow-x-auto px-4 py-2">
          @for (tab of tabs; track tab.key) {
            <button
              class="rounded-full px-3 py-1 text-sm font-medium transition-colors"
              [class.bg-primary]="searchService.activeTab() === tab.key"
              [class.text-white]="searchService.activeTab() === tab.key"
              [class.bg-gray-100]="searchService.activeTab() !== tab.key"
              [class.text-gray-700]="searchService.activeTab() !== tab.key"
              [class.hover:bg-gray-200]="searchService.activeTab() !== tab.key"
              (click)="setTab(tab.key)"
            >
              {{ tab.labelKey | transloco }}
            </button>
          }
        </div>

        <!-- Results list -->
        <div class="min-h-0 flex-1 overflow-y-auto px-4 pb-4">

          @if (!searchService.isLoading() && !hasVisibleHits()) {
            <p class="py-6 text-center text-sm text-secondary">
              {{ 'globalSearch.noResults' | transloco: { query: searchService.query() } }}
            </p>
          }

          @for (category of visibleCategories(); track trackByKey($index, category)) {
            @if (category.hits.length > 0) {
              <!-- Category header -->
              <div class="mb-2 mt-4 text-xs font-semibold uppercase tracking-wider text-secondary">
                {{ categoryLabelKey(category) | transloco }}
              </div>

              <!-- Hits -->
              <ul class="space-y-1">
                @if (isMenuCategory(category)) {
                  @for (hit of category.hits; track trackById($index, hit)) {
                    <li>
                      <button
                        class="flex w-full items-start gap-3 rounded-lg px-3 py-2 text-left transition-colors hover:bg-gray-100"
                        (click)="navigateToMenu(hit.link)"
                      >
                        <mat-icon
                          class="mt-0.5 shrink-0 text-secondary icon-size-5"
                          [svgIcon]="hit.icon || 'heroicons_outline:squares-2x2'"
                        ></mat-icon>
                        <div class="min-w-0">
                          <p class="truncate text-sm font-medium">{{ hit.label }}</p>
                          @if (hit.sublabel) {
                            <p class="truncate text-xs text-secondary">{{ hit.sublabel }}</p>
                          }
                        </div>
                      </button>
                    </li>
                  }
                } @else {
                  @for (hit of category.hits; track trackById($index, hit)) {
                    <li>
                      <button
                        class="flex w-full items-start gap-3 rounded-lg px-3 py-2 text-left transition-colors hover:bg-gray-100"
                        (click)="navigateToHit(hit)"
                      >
                        <div class="min-w-0 flex-1">
                          <p class="truncate text-sm font-medium">{{ hit.label }}</p>
                          @if (hit.sublabel) {
                            <p class="truncate text-xs text-secondary">{{ hit.sublabel }}</p>
                          }
                        </div>
                        @if (hit.status || hit.saldo != null) {
                          <div class="flex shrink-0 flex-col items-end gap-1">
                            @if (hit.status) {
                              <span class="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">
                                {{ hit.status }}
                              </span>
                            }
                            <!-- `!= null` on purpose: a 0 balance must render, not disappear. -->
                            @if (hit.saldo != null) {
                              <span class="whitespace-nowrap text-xs font-medium text-secondary">
                                {{ 'saldo' | transloco }}: ${{ hit.saldo | number: '1.0-0' }}
                              </span>
                            }
                          </div>
                        }
                      </button>
                    </li>
                  }
                }
              </ul>
            }
          }
        </div>
      </div>
    }
  </div>
}
